export const countries = [
    {
        "englishShortName": "Afghanistan",
        "turkishShortName": "Afganistan",
        "alpha2Code": "AF",
        "alpha3Code": "AFG",
        "numeric": 4
      },
      {
        "englishShortName": "Albania",
        "turkishShortName": "Arnavutluk",
        "alpha2Code": "AL",
        "alpha3Code": "ALB",
        "numeric": 8
      },
      {
        "englishShortName": "Algeria",
        "turkishShortName": "Cezayir",
        "alpha2Code": "DZ",
        "alpha3Code": "DZA",
        "numeric": 12
      },
      {
        "englishShortName": "American Samoa",
        "turkishShortName": "Amerikan Samoası",
        "alpha2Code": "AS",
        "alpha3Code": "ASM",
        "numeric": 16
      },
      {
        "englishShortName": "Andorra",
        "turkishShortName": "Andorra",
        "alpha2Code": "AD",
        "alpha3Code": "AND",
        "numeric": 20
      },
      {
        "englishShortName": "Angola",
        "turkishShortName": "Angola",
        "alpha2Code": "AO",
        "alpha3Code": "AGO",
        "numeric": 24
      },
      {
        "englishShortName": "Anguilla",
        "turkishShortName": "Anguilla",
        "alpha2Code": "AI",
        "alpha3Code": "AIA",
        "numeric": 660
      },
      {
        "englishShortName": "Antarctica",
        "turkishShortName": "Antarktika",
        "alpha2Code": "AQ",
        "alpha3Code": "ATA",
        "numeric": 10
      },
      {
        "englishShortName": "Antigua and Barbuda",
        "turkishShortName": "Antigua ve Barbuda",
        "alpha2Code": "AG",
        "alpha3Code": "ATG",
        "numeric": 28
      },
      {
        "englishShortName": "Argentina",
        "turkishShortName": "Arjantin",
        "alpha2Code": "AR",
        "alpha3Code": "ARG",
        "numeric": 32
      },
      {
        "englishShortName": "Armenia",
        "turkishShortName": "Ermenistan",
        "alpha2Code": "AM",
        "alpha3Code": "ARM",
        "numeric": 51
      },
      {
        "englishShortName": "Aruba",
        "turkishShortName": "Aruba",
        "alpha2Code": "AW",
        "alpha3Code": "ABW",
        "numeric": 533
      },
      {
        "englishShortName": "Australia",
        "turkishShortName": "Avustralya",
        "alpha2Code": "AU",
        "alpha3Code": "AUS",
        "numeric": 36
      },
      {
        "englishShortName": "Austria",
        "turkishShortName": "Avusturya",
        "alpha2Code": "AT",
        "alpha3Code": "AUT",
        "numeric": 40
      },
      {
        "englishShortName": "Azerbaijan",
        "turkishShortName": "Azerbaycan",
        "alpha2Code": "AZ",
        "alpha3Code": "AZE",
        "numeric": 31
      },
      {
        "englishShortName": "Bahamas (the)",
        "turkishShortName": "Bahamalar",
        "alpha2Code": "BS",
        "alpha3Code": "BHS",
        "numeric": 44
      },
      {
        "englishShortName": "Bahrain",
        "turkishShortName": "Bahreyn",
        "alpha2Code": "BH",
        "alpha3Code": "BHR",
        "numeric": 48
      },
      {
        "englishShortName": "Bangladesh",
        "turkishShortName": "Bangladeş",
        "alpha2Code": "BD",
        "alpha3Code": "BGD",
        "numeric": 50
      },
      {
        "englishShortName": "Barbados",
        "turkishShortName": "Barbados",
        "alpha2Code": "BB",
        "alpha3Code": "BRB",
        "numeric": 52
      },
      {
        "englishShortName": "Belarus",
        "turkishShortName": "Beyaz Rusya",
        "alpha2Code": "BY",
        "alpha3Code": "BLR",
        "numeric": 112
      },
      {
        "englishShortName": "Belgium",
        "turkishShortName": "Belçika",
        "alpha2Code": "BE",
        "alpha3Code": "BEL",
        "numeric": 56
      },
      {
        "englishShortName": "Belize",
        "turkishShortName": "Belize",
        "alpha2Code": "BZ",
        "alpha3Code": "BLZ",
        "numeric": 84
      },
      {
        "englishShortName": "Benin",
        "turkishShortName": "Benin",
        "alpha2Code": "BJ",
        "alpha3Code": "BEN",
        "numeric": 204
      },
      {
        "englishShortName": "Bermuda",
        "turkishShortName": "Bermuda",
        "alpha2Code": "BM",
        "alpha3Code": "BMU",
        "numeric": 60
      },
      {
        "englishShortName": "Bhutan",
        "turkishShortName": "Butan",
        "alpha2Code": "BT",
        "alpha3Code": "BTN",
        "numeric": 64
      },
      {
        "englishShortName": "Bolivia (Plurinational State of)",
        "turkishShortName": "Bolivya",
        "alpha2Code": "BO",
        "alpha3Code": "BOL",
        "numeric": 68
      },
      {
        "englishShortName": "Bonaire, Sint Eustatius and Saba",
        "turkishShortName": "Bonaire, Sint Eustatius ve Saba",
        "alpha2Code": "BQ",
        "alpha3Code": "BES",
        "numeric": 535
      },
      {
        "englishShortName": "Bosnia and Herzegovina",
        "turkishShortName": "Bosna Hersek",
        "alpha2Code": "BA",
        "alpha3Code": "BIH",
        "numeric": 70
      },
      {
        "englishShortName": "Botswana",
        "turkishShortName": "Botsvana",
        "alpha2Code": "BW",
        "alpha3Code": "BWA",
        "numeric": 72
      },
      {
        "englishShortName": "Bouvet Island",
        "turkishShortName": "Bouvet Adası",
        "alpha2Code": "BV",
        "alpha3Code": "BVT",
        "numeric": 74
      },
      {
        "englishShortName": "Brazil",
        "turkishShortName": "Brezilya",
        "alpha2Code": "BR",
        "alpha3Code": "BRA",
        "numeric": 76
      },
      {
        "englishShortName": "British Indian Ocean Territory (the)",
        "turkishShortName": "Britanya Hint Okyanusu Toprakları",
        "alpha2Code": "IO",
        "alpha3Code": "IOT",
        "numeric": 86
      },
      {
        "englishShortName": "Brunei Darussalam",
        "turkishShortName": "Brunei",
        "alpha2Code": "BN",
        "alpha3Code": "BRN",
        "numeric": 96
      },
      {
        "englishShortName": "Bulgaria",
        "turkishShortName": "Bulgaristan",
        "alpha2Code": "BG",
        "alpha3Code": "BGR",
        "numeric": 100
      },
      {
        "englishShortName": "Burkina Faso",
        "turkishShortName": "Burkina Faso",
        "alpha2Code": "BF",
        "alpha3Code": "BFA",
        "numeric": 854
      },
      {
        "englishShortName": "Burundi",
        "turkishShortName": "Burundi",
        "alpha2Code": "BI",
        "alpha3Code": "BDI",
        "numeric": 108
      },
      {
        "englishShortName": "Cabo Verde",
        "turkishShortName": "Yeşil Burun Adaları",
        "alpha2Code": "CV",
        "alpha3Code": "CPV",
        "numeric": 132
      },
      {
        "englishShortName": "Cambodia",
        "turkishShortName": "Kamboçya",
        "alpha2Code": "KH",
        "alpha3Code": "KHM",
        "numeric": 116
      },
      {
        "englishShortName": "Cameroon",
        "turkishShortName": "Kamerun",
        "alpha2Code": "CM",
        "alpha3Code": "CMR",
        "numeric": 120
      },
      {
        "englishShortName": "Canada",
        "turkishShortName": "Kanada",
        "alpha2Code": "CA",
        "alpha3Code": "CAN",
        "numeric": 124
      },
      {
        "englishShortName": "Cayman Islands (the)",
        "turkishShortName": "Cayman Adaları",
        "alpha2Code": "KY",
        "alpha3Code": "CYM",
        "numeric": 136
      },
      {
        "englishShortName": "Central African Republic (the)",
        "turkishShortName": "Orta Afrika Cumhuriyeti",
        "alpha2Code": "CF",
        "alpha3Code": "CAF",
        "numeric": 140
      },
      {
        "englishShortName": "Chad",
        "turkishShortName": "Çad",
        "alpha2Code": "TD",
        "alpha3Code": "TCD",
        "numeric": 148
      },
      {
        "englishShortName": "Chile",
        "turkishShortName": "Şili",
        "alpha2Code": "CL",
        "alpha3Code": "CHL",
        "numeric": 152
      },
      {
        "englishShortName": "China",
        "turkishShortName": "Çin",
        "alpha2Code": "CN",
        "alpha3Code": "CHN",
        "numeric": 156
      },
      {
        "englishShortName": "Christmas Island",
        "turkishShortName": "Christmas Adası",
        "alpha2Code": "CX",
        "alpha3Code": "CXR",
        "numeric": 162
      },
      {
        "englishShortName": "Cocos (Keeling) Islands (the)",
        "turkishShortName": "Cocos (Keeling) Adaları",
        "alpha2Code": "CC",
        "alpha3Code": "CCK",
        "numeric": 166
      },
      {
        "englishShortName": "Colombia",
        "turkishShortName": "Kolombiya",
        "alpha2Code": "CO",
        "alpha3Code": "COL",
        "numeric": 170
      },
      {
        "englishShortName": "Comoros (the)",
        "turkishShortName": "Komorlar",
        "alpha2Code": "KM",
        "alpha3Code": "COM",
        "numeric": 174
      },
      {
        "englishShortName": "Congo (the Democratic Republic of the)",
        "turkishShortName": "Kongo Demokratik Cumhuriyeti",
        "alpha2Code": "CD",
        "alpha3Code": "COD",
        "numeric": 180
      },
      {
        "englishShortName": "Congo (the)",
        "turkishShortName": "Kongo Cumhuriyeti",
        "alpha2Code": "CG",
        "alpha3Code": "COG",
        "numeric": 178
      },
      {
        "englishShortName": "Cook Islands (the)",
        "turkishShortName": "Cook Adaları",
        "alpha2Code": "CK",
        "alpha3Code": "COK",
        "numeric": 184
      },
      {
        "englishShortName": "Costa Rica",
        "turkishShortName": "Kosta Rika",
        "alpha2Code": "CR",
        "alpha3Code": "CRI",
        "numeric": 188
      },
      {
        "englishShortName": "Croatia",
        "turkishShortName": "Hırvatistan",
        "alpha2Code": "HR",
        "alpha3Code": "HRV",
        "numeric": 191
      },
      {
        "englishShortName": "Cuba",
        "turkishShortName": "Küba",
        "alpha2Code": "CU",
        "alpha3Code": "CUB",
        "numeric": 192
      },
      {
        "englishShortName": "Curaçao",
        "turkishShortName": "Curaçao",
        "alpha2Code": "CW",
        "alpha3Code": "CUW",
        "numeric": 531
      },
      {
        "englishShortName": "Cyprus",
        "turkishShortName": "Kıbrıs",
        "alpha2Code": "CY",
        "alpha3Code": "CYP",
        "numeric": 196
      },
      {
        "englishShortName": "Czechia",
        "turkishShortName": "Çekya",
        "alpha2Code": "CZ",
        "alpha3Code": "CZE",
        "numeric": 203
      },
      {
        "englishShortName": "Côte d'Ivoire",
        "turkishShortName": "Fildişi Sahili",
        "alpha2Code": "CI",
        "alpha3Code": "CIV",
        "numeric": 384
      },
      {
        "englishShortName": "Denmark",
        "turkishShortName": "Danimarka",
        "alpha2Code": "DK",
        "alpha3Code": "DNK",
        "numeric": 208
      },
      {
        "englishShortName": "Djibouti",
        "turkishShortName": "Cibuti",
        "alpha2Code": "DJ",
        "alpha3Code": "DJI",
        "numeric": 262
      },
      {
        "englishShortName": "Dominica",
        "turkishShortName": "Dominika",
        "alpha2Code": "DM",
        "alpha3Code": "DMA",
        "numeric": 212
      },
      {
        "englishShortName": "Dominican Republic (the)",
        "turkishShortName": "Dominik Cumhuriyeti",
        "alpha2Code": "DO",
        "alpha3Code": "DOM",
        "numeric": 214
      },
      {
        "englishShortName": "Ecuador",
        "turkishShortName": "Ekvador",
        "alpha2Code": "EC",
        "alpha3Code": "ECU",
        "numeric": 218
      },
      {
        "englishShortName": "Egypt",
        "turkishShortName": "Mısır",
        "alpha2Code": "EG",
        "alpha3Code": "EGY",
        "numeric": 818
      },
      {
        "englishShortName": "El Salvador",
        "turkishShortName": "El Salvador",
        "alpha2Code": "SV",
        "alpha3Code": "SLV",
        "numeric": 222
      },
      {
        "englishShortName": "Equatorial Guinea",
        "turkishShortName": "Ekvator Ginesi",
        "alpha2Code": "GQ",
        "alpha3Code": "GNQ",
        "numeric": 226
      },
      {
        "englishShortName": "Eritrea",
        "turkishShortName": "Eritre",
        "alpha2Code": "ER",
        "alpha3Code": "ERI",
        "numeric": 232
      },
      {
        "englishShortName": "Estonia",
        "turkishShortName": "Estonya",
        "alpha2Code": "EE",
        "alpha3Code": "EST",
        "numeric": 233
      },
      {
        "englishShortName": "Eswatini",
        "turkishShortName": "Esvatini",
        "alpha2Code": "SZ",
        "alpha3Code": "SWZ",
        "numeric": 748
      },
      {
        "englishShortName": "Ethiopia",
        "turkishShortName": "Etiyopya",
        "alpha2Code": "ET",
        "alpha3Code": "ETH",
        "numeric": 231
      },
      {
        "englishShortName": "Falkland Islands (the) [Malvinas]",
        "turkishShortName": "Falkland Adaları [Malvinas]",
        "alpha2Code": "FK",
        "alpha3Code": "FLK",
        "numeric": 238
      },
      {
        "englishShortName": "Faroe Islands (the)",
        "turkishShortName": "Faroe Adaları",
        "alpha2Code": "FO",
        "alpha3Code": "FRO",
        "numeric": 234
      },
      {
        "englishShortName": "Fiji",
        "turkishShortName": "Fiji",
        "alpha2Code": "FJ",
        "alpha3Code": "FJI",
        "numeric": 242
      },
      {
        "englishShortName": "Finland",
        "turkishShortName": "Finlandiya",
        "alpha2Code": "FI",
        "alpha3Code": "FIN",
        "numeric": 246
      },
      {
        "englishShortName": "France",
        "turkishShortName": "Fransa",
        "alpha2Code": "FR",
        "alpha3Code": "FRA",
        "numeric": 250
      },
      {
        "englishShortName": "French Guiana",
        "turkishShortName": "Fransız Guyanası",
        "alpha2Code": "GF",
        "alpha3Code": "GUF",
        "numeric": 254
      },
      {
        "englishShortName": "French Polynesia",
        "turkishShortName": "Fransız Polinezyası",
        "alpha2Code": "PF",
        "alpha3Code": "PYF",
        "numeric": 258
      },
      {
        "englishShortName": "French Southern Territories (the)",
        "turkishShortName": "Fransız Güney Toprakları",
        "alpha2Code": "TF",
        "alpha3Code": "ATF",
        "numeric": 260
      },
      {
        "englishShortName": "Gabon",
        "turkishShortName": "Gabon",
        "alpha2Code": "GA",
        "alpha3Code": "GAB",
        "numeric": 266
      },
      {
        "englishShortName": "Gambia (the)",
        "turkishShortName": "Gambiya",
        "alpha2Code": "GM",
        "alpha3Code": "GMB",
        "numeric": 270
      },
      {
        "englishShortName": "Georgia",
        "turkishShortName": "Gürcistan",
        "alpha2Code": "GE",
        "alpha3Code": "GEO",
        "numeric": 268
      },
      {
        "englishShortName": "Germany",
        "turkishShortName": "Almanya",
        "alpha2Code": "DE",
        "alpha3Code": "DEU",
        "numeric": 276
      },
      {
        "englishShortName": "Ghana",
        "turkishShortName": "Gana",
        "alpha2Code": "GH",
        "alpha3Code": "GHA",
        "numeric": 288
      },
      {
        "englishShortName": "Gibraltar",
        "turkishShortName": "Cebelitarık",
        "alpha2Code": "GI",
        "alpha3Code": "GIB",
        "numeric": 292
      },
      {
        "englishShortName": "Greece",
        "turkishShortName": "Yunanistan",
        "alpha2Code": "GR",
        "alpha3Code": "GRC",
        "numeric": 300
      },
      {
        "englishShortName": "Greenland",
        "turkishShortName": "Grönland",
        "alpha2Code": "GL",
        "alpha3Code": "GRL",
        "numeric": 304
      },
      {
        "englishShortName": "Grenada",
        "turkishShortName": "Grenada",
        "alpha2Code": "GD",
        "alpha3Code": "GRD",
        "numeric": 308
      },
      {
        "englishShortName": "Guadeloupe",
        "turkishShortName": "Guadeloupe",
        "alpha2Code": "GP",
        "alpha3Code": "GLP",
        "numeric": 312
      },
      {
        "englishShortName": "Guam",
        "turkishShortName": "Guam",
        "alpha2Code": "GU",
        "alpha3Code": "GUM",
        "numeric": 316
      },
      {
        "englishShortName": "Guatemala",
        "turkishShortName": "Guatemala",
        "alpha2Code": "GT",
        "alpha3Code": "GTM",
        "numeric": 320
      },
      {
        "englishShortName": "Guernsey",
        "turkishShortName": "Guernsey",
        "alpha2Code": "GG",
        "alpha3Code": "GGY",
        "numeric": 831
      },
      {
        "englishShortName": "Guinea",
        "turkishShortName": "Gine",
        "alpha2Code": "GN",
        "alpha3Code": "GIN",
        "numeric": 324
      },
      {
        "englishShortName": "Guinea-Bissau",
        "turkishShortName": "Gine-Bissau",
        "alpha2Code": "GW",
        "alpha3Code": "GNB",
        "numeric": 624
      },
      {
        "englishShortName": "Guyana",
        "turkishShortName": "Guyana",
        "alpha2Code": "GY",
        "alpha3Code": "GUY",
        "numeric": 328
      },
      {
        "englishShortName": "Haiti",
        "turkishShortName": "Haiti",
        "alpha2Code": "HT",
        "alpha3Code": "HTI",
        "numeric": 332
      },
      {
        "englishShortName": "Heard Island and McDonald Islands",
        "turkishShortName": "Heard Adası ve McDonald Adaları",
        "alpha2Code": "HM",
        "alpha3Code": "HMD",
        "numeric": 334
      },
      {
        "englishShortName": "Holy See (the)",
        "turkishShortName": "Vatikan",
        "alpha2Code": "VA",
        "alpha3Code": "VAT",
        "numeric": 336
      },
      {
        "englishShortName": "Honduras",
        "turkishShortName": "Honduras",
        "alpha2Code": "HN",
        "alpha3Code": "HND",
        "numeric": 340
      },
      {
        "englishShortName": "Hong Kong",
        "turkishShortName": "Hong Kong",
        "alpha2Code": "HK",
        "alpha3Code": "HKG",
        "numeric": 344
      },
      {
        "englishShortName": "Hungary",
        "turkishShortName": "Macaristan",
        "alpha2Code": "HU",
        "alpha3Code": "HUN",
        "numeric": 348
      },
      {
        "englishShortName": "Iceland",
        "turkishShortName": "İzlanda",
        "alpha2Code": "IS",
        "alpha3Code": "ISL",
        "numeric": 352
      },
      {
        "englishShortName": "India",
        "turkishShortName": "Hindistan",
        "alpha2Code": "IN",
        "alpha3Code": "IND",
        "numeric": 356
      },
      {
        "englishShortName": "Indonesia",
        "turkishShortName": "Endonezya",
        "alpha2Code": "ID",
        "alpha3Code": "IDN",
        "numeric": 360
      },
      {
        "englishShortName": "Iran (Islamic Republic of)",
        "turkishShortName": "İran",
        "alpha2Code": "IR",
        "alpha3Code": "IRN",
        "numeric": 364
      },
      {
        "englishShortName": "Iraq",
        "turkishShortName": "Irak",
        "alpha2Code": "IQ",
        "alpha3Code": "IRQ",
        "numeric": 368
      },
      {
        "englishShortName": "Ireland",
        "turkishShortName": "İrlanda",
        "alpha2Code": "IE",
        "alpha3Code": "IRL",
        "numeric": 372
      },
      {
        "englishShortName": "Isle of Man",
        "turkishShortName": "Man Adası",
        "alpha2Code": "IM",
        "alpha3Code": "IMN",
        "numeric": 833
      },
      {
        "englishShortName": "Israel",
        "turkishShortName": "İsrail",
        "alpha2Code": "IL",
        "alpha3Code": "ISR",
        "numeric": 376
      },
      {
        "englishShortName": "Italy",
        "turkishShortName": "İtalya",
        "alpha2Code": "IT",
        "alpha3Code": "ITA",
        "numeric": 380
      },
      {
        "englishShortName": "Jamaica",
        "turkishShortName": "Jamaika",
        "alpha2Code": "JM",
        "alpha3Code": "JAM",
        "numeric": 388
      },
      {
        "englishShortName": "Japan",
        "turkishShortName": "Japonya",
        "alpha2Code": "JP",
        "alpha3Code": "JPN",
        "numeric": 392
      },
      {
        "englishShortName": "Jersey",
        "turkishShortName": "Jersey",
        "alpha2Code": "JE",
        "alpha3Code": "JEY",
        "numeric": 832
      },
      {
        "englishShortName": "Jordan",
        "turkishShortName": "Ürdün",
        "alpha2Code": "JO",
        "alpha3Code": "JOR",
        "numeric": 400
      },
      {
        "englishShortName": "Kazakhstan",
        "turkishShortName": "Kazakistan",
        "alpha2Code": "KZ",
        "alpha3Code": "KAZ",
        "numeric": 398
      },
      {
        "englishShortName": "Kenya",
        "turkishShortName": "Kenya",
        "alpha2Code": "KE",
        "alpha3Code": "KEN",
        "numeric": 404
      },
      {
        "englishShortName": "Kiribati",
        "turkishShortName": "Kiribati",
        "alpha2Code": "KI",
        "alpha3Code": "KIR",
        "numeric": 296
      },
      {
        "englishShortName": "Korea (the Democratic People's Republic of)",
        "turkishShortName": "Kuzey Kore",
        "alpha2Code": "KP",
        "alpha3Code": "PRK",
        "numeric": 408
      },
      {
        "englishShortName": "Korea (the Republic of)",
        "turkishShortName": "Güney Kore",
        "alpha2Code": "KR",
        "alpha3Code": "KOR",
        "numeric": 410
      },
      {
        "englishShortName": "Kuwait",
        "turkishShortName": "Kuveyt",
        "alpha2Code": "KW",
        "alpha3Code": "KWT",
        "numeric": 414
      },
      {
        "englishShortName": "Kyrgyzstan",
        "turkishShortName": "Kırgızistan",
        "alpha2Code": "KG",
        "alpha3Code": "KGZ",
        "numeric": 417
      },
      {
        "englishShortName": "Lao People's Democratic Republic (the)",
        "turkishShortName": "Laos",
        "alpha2Code": "LA",
        "alpha3Code": "LAO",
        "numeric": 418
      },
      {
        "englishShortName": "Latvia",
        "turkishShortName": "Letonya",
        "alpha2Code": "LV",
        "alpha3Code": "LVA",
        "numeric": 428
      },
      {
        "englishShortName": "Lebanon",
        "turkishShortName": "Lübnan",
        "alpha2Code": "LB",
        "alpha3Code": "LBN",
        "numeric": 422
      },
      {
        "englishShortName": "Lesotho",
        "turkishShortName": "Lesotho",
        "alpha2Code": "LS",
        "alpha3Code": "LSO",
        "numeric": 426
      },
      {
        "englishShortName": "Liberia",
        "turkishShortName": "Liberya",
        "alpha2Code": "LR",
        "alpha3Code": "LBR",
        "numeric": 430
      },
      {
        "englishShortName": "Libya",
        "turkishShortName": "Libya",
        "alpha2Code": "LY",
        "alpha3Code": "LBY",
        "numeric": 434
      },
      {
        "englishShortName": "Liechtenstein",
        "turkishShortName": "Lihtenştayn",
        "alpha2Code": "LI",
        "alpha3Code": "LIE",
        "numeric": 438
      },
      {
        "englishShortName": "Lithuania",
        "turkishShortName": "Litvanya",
        "alpha2Code": "LT",
        "alpha3Code": "LTU",
        "numeric": 440
      },
      {
        "englishShortName": "Luxembourg",
        "turkishShortName": "Lüksemburg",
        "alpha2Code": "LU",
        "alpha3Code": "LUX",
        "numeric": 442
      },
      {
        "englishShortName": "Macao",
        "turkishShortName": "Makao",
        "alpha2Code": "MO",
        "alpha3Code": "MAC",
        "numeric": 446
      },
      {
        "englishShortName": "Madagascar",
        "turkishShortName": "Madagaskar",
        "alpha2Code": "MG",
        "alpha3Code": "MDG",
        "numeric": 450
      },
      {
        "englishShortName": "Malawi",
        "turkishShortName": "Malavi",
        "alpha2Code": "MW",
        "alpha3Code": "MWI",
        "numeric": 454
      },
      {
        "englishShortName": "Malaysia",
        "turkishShortName": "Malezya",
        "alpha2Code": "MY",
        "alpha3Code": "MYS",
        "numeric": 458
      },
      {
        "englishShortName": "Maldives",
        "turkishShortName": "Maldivler",
        "alpha2Code": "MV",
        "alpha3Code": "MDV",
        "numeric": 462
      },
      {
        "englishShortName": "Mali",
        "turkishShortName": "Mali",
        "alpha2Code": "ML",
        "alpha3Code": "MLI",
        "numeric": 466
      },
      {
        "englishShortName": "Malta",
        "turkishShortName": "Malta",
        "alpha2Code": "MT",
        "alpha3Code": "MLT",
        "numeric": 470
      },
      {
        "englishShortName": "Marshall Islands (the)",
        "turkishShortName": "Marshall Adaları",
        "alpha2Code": "MH",
        "alpha3Code": "MHL",
        "numeric": 584
      },
      {
        "englishShortName": "Martinique",
        "turkishShortName": "Martinik",
        "alpha2Code": "MQ",
        "alpha3Code": "MTQ",
        "numeric": 474
      },
      {
        "englishShortName": "Mauritania",
        "turkishShortName": "Moritanya",
        "alpha2Code": "MR",
        "alpha3Code": "MRT",
        "numeric": 478
      },
      {
        "englishShortName": "Mauritius",
        "turkishShortName": "Mauritius",
        "alpha2Code": "MU",
        "alpha3Code": "MUS",
        "numeric": 480
      },
      {
        "englishShortName": "Mayotte",
        "turkishShortName": "Mayotte",
        "alpha2Code": "YT",
        "alpha3Code": "MYT",
        "numeric": 175
      },
      {
        "englishShortName": "Mexico",
        "turkishShortName": "Meksika",
        "alpha2Code": "MX",
        "alpha3Code": "MEX",
        "numeric": 484
      },
      {
        "englishShortName": "Micronesia (Federated States of)",
        "turkishShortName": "Mikronezya (Birleşik Devletleri)",
        "alpha2Code": "FM",
        "alpha3Code": "FSM",
        "numeric": 583
      },
      {
        "englishShortName": "Moldova (the Republic of)",
        "turkishShortName": "Moldova Cumhuriyeti",
        "alpha2Code": "MD",
        "alpha3Code": "MDA",
        "numeric": 498
      },
      {
        "englishShortName": "Monaco",
        "turkishShortName": "Monako",
        "alpha2Code": "MC",
        "alpha3Code": "MCO",
        "numeric": 492
      },
      {
        "englishShortName": "Mongolia",
        "turkishShortName": "Moğolistan",
        "alpha2Code": "MN",
        "alpha3Code": "MNG",
        "numeric": 496
      },
      {
        "englishShortName": "Montenegro",
        "turkishShortName": "Karadağ",
        "alpha2Code": "ME",
        "alpha3Code": "MNE",
        "numeric": 499
      },
      {
        "englishShortName": "Montserrat",
        "turkishShortName": "Montserrat",
        "alpha2Code": "MS",
        "alpha3Code": "MSR",
        "numeric": 500
      },
      {
        "englishShortName": "Morocco",
        "turkishShortName": "Fas",
        "alpha2Code": "MA",
        "alpha3Code": "MAR",
        "numeric": 504
      },
      {
        "englishShortName": "Mozambique",
        "turkishShortName": "Mozambik",
        "alpha2Code": "MZ",
        "alpha3Code": "MOZ",
        "numeric": 508
      },
      {
        "englishShortName": "Myanmar",
        "turkishShortName": "Myanmar",
        "alpha2Code": "MM",
        "alpha3Code": "MMR",
        "numeric": 104
      },
      {
        "englishShortName": "Namibia",
        "turkishShortName": "Namibya",
        "alpha2Code": "NA",
        "alpha3Code": "NAM",
        "numeric": 516
      },
      {
        "englishShortName": "Nauru",
        "turkishShortName": "Nauru",
        "alpha2Code": "NR",
        "alpha3Code": "NRU",
        "numeric": 520
      },
      {
        "englishShortName": "Nepal",
        "turkishShortName": "Nepal",
        "alpha2Code": "NP",
        "alpha3Code": "NPL",
        "numeric": 524
      },
      {
        "englishShortName": "Netherlands (the)",
        "turkishShortName": "Hollanda",
        "alpha2Code": "NL",
        "alpha3Code": "NLD",
        "numeric": 528
      },
      {
        "englishShortName": "New Caledonia",
        "turkishShortName": "Yeni Kaledonya",
        "alpha2Code": "NC",
        "alpha3Code": "NCL",
        "numeric": 540
      },
      {
        "englishShortName": "New Zealand",
        "turkishShortName": "Yeni Zelanda",
        "alpha2Code": "NZ",
        "alpha3Code": "NZL",
        "numeric": 554
      },
      {
        "englishShortName": "Nicaragua",
        "turkishShortName": "Nikaragua",
        "alpha2Code": "NI",
        "alpha3Code": "NIC",
        "numeric": 558
      },
      {
        "englishShortName": "Niger (the)",
        "turkishShortName": "Nijer",
        "alpha2Code": "NE",
        "alpha3Code": "NER",
        "numeric": 562
      },
      {
        "englishShortName": "Nigeria",
        "turkishShortName": "Nijerya",
        "alpha2Code": "NG",
        "alpha3Code": "NGA",
        "numeric": 566
      },
      {
        "englishShortName": "Niue",
        "turkishShortName": "Niue",
        "alpha2Code": "NU",
        "alpha3Code": "NIU",
        "numeric": 570
      },
      {
        "englishShortName": "Norfolk Island",
        "turkishShortName": "Norfolk Adası",
        "alpha2Code": "NF",
        "alpha3Code": "NFK",
        "numeric": 574
      },
      {
        "englishShortName": "North Macedonia",
        "turkishShortName": "Kuzey Makedonya",
        "alpha2Code": "MK",
        "alpha3Code": "MKD",
        "numeric": 807
      },
      {
        "englishShortName": "Northern Mariana Islands (the)",
        "turkishShortName": "Kuzey Mariana Adaları",
        "alpha2Code": "MP",
        "alpha3Code": "MNP",
        "numeric": 580
      },
      {
        "englishShortName": "Norway",
        "turkishShortName": "Norveç",
        "alpha2Code": "NO",
        "alpha3Code": "NOR",
        "numeric": 578
      },
      {
        "englishShortName": "Oman",
        "turkishShortName": "Umman",
        "alpha2Code": "OM",
        "alpha3Code": "OMN",
        "numeric": 512
      },
      {
        "englishShortName": "Pakistan",
        "turkishShortName": "Pakistan",
        "alpha2Code": "PK",
        "alpha3Code": "PAK",
        "numeric": 586
      },
      {
        "englishShortName": "Palau",
        "turkishShortName": "Palau",
        "alpha2Code": "PW",
        "alpha3Code": "PLW",
        "numeric": 585
      },
      {
        "englishShortName": "Palestine, State of",
        "turkishShortName": "Filistin",
        "alpha2Code": "PS",
        "alpha3Code": "PSE",
        "numeric": 275
      },
      {
        "englishShortName": "Panama",
        "turkishShortName": "Panama",
        "alpha2Code": "PA",
        "alpha3Code": "PAN",
        "numeric": 591
      },
      {
        "englishShortName": "Papua New Guinea",
        "turkishShortName": "Papua Yeni Gine",
        "alpha2Code": "PG",
        "alpha3Code": "PNG",
        "numeric": 598
      },
      {
        "englishShortName": "Paraguay",
        "turkishShortName": "Paraguay",
        "alpha2Code": "PY",
        "alpha3Code": "PRY",
        "numeric": 600
      },
      {
        "englishShortName": "Peru",
        "turkishShortName": "Peru",
        "alpha2Code": "PE",
        "alpha3Code": "PER",
        "numeric": 604
      },
      {
        "englishShortName": "Philippines (the)",
        "turkishShortName": "Filipinler",
        "alpha2Code": "PH",
        "alpha3Code": "PHL",
        "numeric": 608
      },
      {
        "englishShortName": "Pitcairn",
        "turkishShortName": "Pitcairn Adaları",
        "alpha2Code": "PN",
        "alpha3Code": "PCN",
        "numeric": 612
      },
      {
        "englishShortName": "Poland",
        "turkishShortName": "Polonya",
        "alpha2Code": "PL",
        "alpha3Code": "POL",
        "numeric": 616
      },
      {
        "englishShortName": "Portugal",
        "turkishShortName": "Portekiz",
        "alpha2Code": "PT",
        "alpha3Code": "PRT",
        "numeric": 620
      },
      {
        "englishShortName": "Puerto Rico",
        "turkishShortName": "Porto Riko",
        "alpha2Code": "PR",
        "alpha3Code": "PRI",
        "numeric": 630
      },
      {
        "englishShortName": "Qatar",
        "turkishShortName": "Katar",
        "alpha2Code": "QA",
        "alpha3Code": "QAT",
        "numeric": 634
      },
      {
        "englishShortName": "Romania",
        "turkishShortName": "Romanya",
        "alpha2Code": "RO",
        "alpha3Code": "ROU",
        "numeric": 642
      },
      {
        "englishShortName": "Russian Federation (the)",
        "turkishShortName": "Rusya Federasyonu",
        "alpha2Code": "RU",
        "alpha3Code": "RUS",
        "numeric": 643
      },
      {
        "englishShortName": "Rwanda",
        "turkishShortName": "Ruanda",
        "alpha2Code": "RW",
        "alpha3Code": "RWA",
        "numeric": 646
      },
      {
        "englishShortName": "Réunion",
        "turkishShortName": "Réunion",
        "alpha2Code": "RE",
        "alpha3Code": "REU",
        "numeric": 638
      },
      {
        "englishShortName": "Saint Barthélemy",
        "turkishShortName": "Saint-Barthélemy",
        "alpha2Code": "BL",
        "alpha3Code": "BLM",
        "numeric": 652
      },
      {
        "englishShortName": "Saint Helena, Ascension and Tristan da Cunha",
        "turkishShortName": "Saint Helena, Ascension ve Tristan da Cunha",
        "alpha2Code": "SH",
        "alpha3Code": "SHN",
        "numeric": 654
      },
      {
        "englishShortName": "Saint Kitts and Nevis",
        "turkishShortName": "Saint Kitts ve Nevis",
        "alpha2Code": "KN",
        "alpha3Code": "KNA",
        "numeric": 659
      },
      {
        "englishShortName": "Saint Lucia",
        "turkishShortName": "Saint Lucia",
        "alpha2Code": "LC",
        "alpha3Code": "LCA",
        "numeric": 662
      },
      {
        "englishShortName": "Saint Martin (French part)",
        "turkishShortName": "Saint Martin (Fransız bölgesi)",
        "alpha2Code": "MF",
        "alpha3Code": "MAF",
        "numeric": 663
      },
      {
        "englishShortName": "Saint Pierre and Miquelon",
        "turkishShortName": "Saint Pierre ve Miquelon",
        "alpha2Code": "PM",
        "alpha3Code": "SPM",
        "numeric": 666
      },
      {
        "englishShortName": "Saint Vincent and the Grenadines",
        "turkishShortName": "Saint Vincent ve Grenadinler",
        "alpha2Code": "VC",
        "alpha3Code": "VCT",
        "numeric": 670
      },
      {
        "englishShortName": "Samoa",
        "turkishShortName": "Samoa",
        "alpha2Code": "WS",
        "alpha3Code": "WSM",
        "numeric": 882
      },
      {
        "englishShortName": "San Marino",
        "turkishShortName": "San Marino",
        "alpha2Code": "SM",
        "alpha3Code": "SMR",
        "numeric": 674
      },
      {
        "englishShortName": "Sao Tome and Principe",
        "turkishShortName": "São Tomé ve Príncipe",
        "alpha2Code": "ST",
        "alpha3Code": "STP",
        "numeric": 678
      },
      {
        "englishShortName": "Saudi Arabia",
        "turkishShortName": "Suudi Arabistan",
        "alpha2Code": "SA",
        "alpha3Code": "SAU",
        "numeric": 682
      },
      {
        "englishShortName": "Senegal",
        "turkishShortName": "Senegal",
        "alpha2Code": "SN",
        "alpha3Code": "SEN",
        "numeric": 686
      },
      {
        "englishShortName": "Serbia",
        "turkishShortName": "Sırbistan",
        "alpha2Code": "RS",
        "alpha3Code": "SRB",
        "numeric": 688
      },
      {
        "englishShortName": "Seychelles",
        "turkishShortName": "Seyşeller",
        "alpha2Code": "SC",
        "alpha3Code": "SYC",
        "numeric": 690
      },
      {
        "englishShortName": "Sierra Leone",
        "turkishShortName": "Sierra Leone",
        "alpha2Code": "SL",
        "alpha3Code": "SLE",
        "numeric": 694
      },
      {
        "englishShortName": "Singapore",
        "turkishShortName": "Singapur",
        "alpha2Code": "SG",
        "alpha3Code": "SGP",
        "numeric": 702
      },
      {
        "englishShortName": "Sint Maarten (Dutch part)",
        "turkishShortName": "Sint Maarten (Hollanda bölgesi)",
        "alpha2Code": "SX",
        "alpha3Code": "SXM",
        "numeric": 534
      },
      {
        "englishShortName": "Slovakia",
        "turkishShortName": "Slovakya",
        "alpha2Code": "SK",
        "alpha3Code": "SVK",
        "numeric": 703
      },
      {
        "englishShortName": "Slovenia",
        "turkishShortName": "Slovenya",
        "alpha2Code": "SI",
        "alpha3Code": "SVN",
        "numeric": 705
      },
      {
        "englishShortName": "Solomon Islands",
        "turkishShortName": "Solomon Adaları",
        "alpha2Code": "SB",
        "alpha3Code": "SLB",
        "numeric": 90
      },
      {
        "englishShortName": "Somalia",
        "turkishShortName": "Somali",
        "alpha2Code": "SO",
        "alpha3Code": "SOM",
        "numeric": 706
      },
      {
        "englishShortName": "South Africa",
        "turkishShortName": "Güney Afrika",
        "alpha2Code": "ZA",
        "alpha3Code": "ZAF",
        "numeric": 710
      },
      {
        "englishShortName": "South Georgia and the South Sandwich Islands",
        "turkishShortName": "Güney Georgia ve Güney Sandwich Adaları",
        "alpha2Code": "GS",
        "alpha3Code": "SGS",
        "numeric": 239
      },
      {
        "englishShortName": "South Sudan",
        "turkishShortName": "Güney Sudan",
        "alpha2Code": "SS",
        "alpha3Code": "SSD",
        "numeric": 728
      },
      {
        "englishShortName": "Spain",
        "turkishShortName": "İspanya",
        "alpha2Code": "ES",
        "alpha3Code": "ESP",
        "numeric": 724
      },
      {
        "englishShortName": "Sri Lanka",
        "turkishShortName": "Sri Lanka",
        "alpha2Code": "LK",
        "alpha3Code": "LKA",
        "numeric": 144
      },
      {
        "englishShortName": "Sudan (the)",
        "turkishShortName": "Sudan",
        "alpha2Code": "SD",
        "alpha3Code": "SDN",
        "numeric": 729
      },
      {
        "englishShortName": "Suriname",
        "turkishShortName": "Surinam",
        "alpha2Code": "SR",
        "alpha3Code": "SUR",
        "numeric": 740
      },
      {
        "englishShortName": "Svalbard and Jan Mayen",
        "turkishShortName": "Svalbard ve Jan Mayen",
        "alpha2Code": "SJ",
        "alpha3Code": "SJM",
        "numeric": 744
      },
      {
        "englishShortName": "Sweden",
        "turkishShortName": "İsveç",
        "alpha2Code": "SE",
        "alpha3Code": "SWE",
        "numeric": 752
      },
      {
        "englishShortName": "Switzerland",
        "turkishShortName": "İsviçre",
        "alpha2Code": "CH",
        "alpha3Code": "CHE",
        "numeric": 756
      },
      {
        "englishShortName": "Syrian Arab Republic (the)",
        "turkishShortName": "Suriye Arap Cumhuriyeti",
        "alpha2Code": "SY",
        "alpha3Code": "SYR",
        "numeric": 760
      },
      {
        "englishShortName": "Taiwan (Province of China)",
        "turkishShortName": "Tayvan (Çin Eyaleti)",
        "alpha2Code": "TW",
        "alpha3Code": "TWN",
        "numeric": 158
      },
      {
        "englishShortName": "Tajikistan",
        "turkishShortName": "Tacikistan",
        "alpha2Code": "TJ",
        "alpha3Code": "TJK",
        "numeric": 762
      },
      {
        "englishShortName": "Tanzania, the United Republic of",
        "turkishShortName": "Tanzanya Birleşik Cumhuriyeti",
        "alpha2Code": "TZ",
        "alpha3Code": "TZA",
        "numeric": 834
      },
      {
        "englishShortName": "Thailand",
        "turkishShortName": "Tayland",
        "alpha2Code": "TH",
        "alpha3Code": "THA",
        "numeric": 764
      },
      {
        "englishShortName": "Timor-Leste",
        "turkishShortName": "Doğu Timor",
        "alpha2Code": "TL",
        "alpha3Code": "TLS",
        "numeric": 626
      },
      {
        "englishShortName": "Togo",
        "turkishShortName": "Togo",
        "alpha2Code": "TG",
        "alpha3Code": "TGO",
        "numeric": 768
      },
      {
        "englishShortName": "Tokelau",
        "turkishShortName": "Tokelau",
        "alpha2Code": "TK",
        "alpha3Code": "TKL",
        "numeric": 772
      },
      {
        "englishShortName": "Tonga",
        "turkishShortName": "Tonga",
        "alpha2Code": "TO",
        "alpha3Code": "TON",
        "numeric": 776
      },
      {
        "englishShortName": "Trinidad and Tobago",
        "turkishShortName": "Trinidad ve Tobago",
        "alpha2Code": "TT",
        "alpha3Code": "TTO",
        "numeric": 780
      },
      {
        "englishShortName": "Tunisia",
        "turkishShortName": "Tunus",
        "alpha2Code": "TN",
        "alpha3Code": "TUN",
        "numeric": 788
      },
      {
        "englishShortName": "Turkey",
        "turkishShortName": "Türkiye",
        "alpha2Code": "TR",
        "alpha3Code": "TUR",
        "numeric": 792
      },
      {
        "englishShortName": "Turkmenistan",
        "turkishShortName": "Türkmenistan",
        "alpha2Code": "TM",
        "alpha3Code": "TKM",
        "numeric": 795
      },
      {
        "englishShortName": "Turks and Caicos Islands (the)",
        "turkishShortName": "Turks ve Caicos Adaları",
        "alpha2Code": "TC",
        "alpha3Code": "TCA",
        "numeric": 796
      },
      {
        "englishShortName": "Tuvalu",
        "turkishShortName": "Tuvalu",
        "alpha2Code": "TV",
        "alpha3Code": "TUV",
        "numeric": 798
      },
      {
        "englishShortName": "Uganda",
        "turkishShortName": "Uganda",
        "alpha2Code": "UG",
        "alpha3Code": "UGA",
        "numeric": 800
      },
      {
        "englishShortName": "Ukraine",
        "turkishShortName": "Ukrayna",
        "alpha2Code": "UA",
        "alpha3Code": "UKR",
        "numeric": 804
      },
      {
        "englishShortName": "United Arab Emirates (the)",
        "turkishShortName": "Birleşik Arap Emirlikleri",
        "alpha2Code": "AE",
        "alpha3Code": "ARE",
        "numeric": 784
      },
      {
        "englishShortName": "United Kingdom of Great Britain and Northern Ireland (the)",
        "turkishShortName": "Birleşik Krallık",
        "alpha2Code": "GB",
        "alpha3Code": "GBR",
        "numeric": 826
      },
      {
        "englishShortName": "United States Minor Outlying Islands (the)",
        "turkishShortName": "Amerika Birleşik Devletleri Küçük Dış Adaları",
        "alpha2Code": "UM",
        "alpha3Code": "UMI",
        "numeric": 581
      },
      {
        "englishShortName": "United States of America (the)",
        "turkishShortName": "Amerika Birleşik Devletleri",
        "alpha2Code": "US",
        "alpha3Code": "USA",
        "numeric": 840
      },
      {
        "englishShortName": "Uruguay",
        "turkishShortName": "Uruguay",
        "alpha2Code": "UY",
        "alpha3Code": "URY",
        "numeric": 858
      },
      {
        "englishShortName": "Uzbekistan",
        "turkishShortName": "Özbekistan",
        "alpha2Code": "UZ",
        "alpha3Code": "UZB",
        "numeric": 860
      },
      {
        "englishShortName": "Vanuatu",
        "turkishShortName": "Vanuatu",
        "alpha2Code": "VU",
        "alpha3Code": "VUT",
        "numeric": 548
      },
      {
        "englishShortName": "Venezuela (Bolivarian Republic of)",
        "turkishShortName": "Venezuela",
        "alpha2Code": "VE",
        "alpha3Code": "VEN",
        "numeric": 862
      },
      {
        "englishShortName": "Viet Nam",
        "turkishShortName": "Vietnam",
        "alpha2Code": "VN",
        "alpha3Code": "VNM",
        "numeric": 704
      },
      {
        "englishShortName": "Virgin Islands (British)",
        "turkishShortName": "Britanya Virgin Adaları",
        "alpha2Code": "VG",
        "alpha3Code": "VGB",
        "numeric": 92
      },
      {
        "englishShortName": "Virgin Islands (U.S.)",
        "turkishShortName": "ABD Virgin Adaları",
        "alpha2Code": "VI",
        "alpha3Code": "VIR",
        "numeric": 850
      },
      {
        "englishShortName": "Wallis and Futuna",
        "turkishShortName": "Wallis ve Futuna",
        "alpha2Code": "WF",
        "alpha3Code": "WLF",
        "numeric": 876
      },
      {
        "englishShortName": "Western Sahara*",
        "turkishShortName": "Batı Sahra",
        "alpha2Code": "EH",
        "alpha3Code": "ESH",
        "numeric": 732
      },
      {
        "englishShortName": "Yemen",
        "turkishShortName": "Yemen",
        "alpha2Code": "YE",
        "alpha3Code": "YEM",
        "numeric": 887
      },
      {
        "englishShortName": "Zambia",
        "turkishShortName": "Zambiya",
        "alpha2Code": "ZM",
        "alpha3Code": "ZMB",
        "numeric": 894
      },
      {
        "englishShortName": "Zimbabwe",
        "turkishShortName": "Zimbabve",
        "alpha2Code": "ZW",
        "alpha3Code": "ZWE",
        "numeric": 716
      },
      {
        "englishShortName": "Åland Islands",
        "turkishShortName": "Åland Adaları",
        "alpha2Code": "AX",
        "alpha3Code": "ALA",
        "numeric": 248
      }
]